// extracted by mini-css-extract-plugin
module.exports = {"button":"CommonButtonWrapper_button__g303L"};